import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ClientFormComponent } from '../../components/client-form/client-form.component';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { ClientRequest } from '../../client.model';
import { ClientStore } from '../../client.store';
import {SHARED_IMPORTS} from "../../../../shared/modules/shared-imports.module";

@Component({
  selector: 'app-client-create-page',
  imports: [RouterLink, ClientFormComponent, ...SharedMaterialUIModule, ...SHARED_IMPORTS],
  templateUrl: './client-create.page.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ClientCreatePage {
  private readonly router = inject(Router);
  protected readonly clientStore = inject(ClientStore);

  protected onSubmit(request: ClientRequest): void {
    this.clientStore.createClient(request, () => {
      void this.router.navigate(['/clients']);
    });
  }
}
